export default __webpack_public_path__ + "static/media/waving.98d581f7.svg";